import { useRequest } from '~/lib/useRequest';
import { ProgramResource } from '@ab/ams-school-api/src/resources/programs';
import { useQuery } from '@tanstack/react-query';
import { config } from '~/config';
import { hasKey } from '~/utils';
import { GetProgramResponse } from '@ab/ams-school-api/types/private/v1';

export type Program = ProgramResource['attributes'] & {
  id: ProgramResource['id'];
};

export function useProgram(id: string, options?: { onSuccess?: (data: ProgramResource) => void }) {
  const request = useRequest();

  const { isLoading, isFetching, error, data, isError } = useQuery({
    queryKey: ['program', id],
    queryFn: async () => {
      const response = await request<GetProgramResponse>(
        `${config.apiHost}/private/v1/programs/${id}?include=field_of_study,program_level`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      const program = response.data;
      const attrs = {
        id: program.id,
        ...program.attributes,
      };

      options?.onSuccess?.(program);

      return attrs;
    },
  });
  return {
    isLoadingProgram: isLoading,
    isFetchingProgram: isFetching,
    programError: error,
    program: data,
    isProgramError: isError,
  };
}

function isExpectedResponse(res: unknown): res is GetProgramResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
